import { environment } from '../../environments/environment';
/**
 * Configuración de autenticación Keycloak
 * Ajusta estos valores según tu configuración de Keycloak
 */
export const authConfig = {
  // URL del servidor Keycloak
  keycloakUrl: environment.keycloakUrl,
  
  // Client ID configurado en Keycloak
  // IMPORTANTE: Debes crear un cliente en Keycloak con este ID
  clientId: environment.clientId,
  
  // Client Secret (solo si el cliente está configurado como "confidential")
  // Si el cliente es "public", deja esto como null o undefined
  clientSecret: environment.clientSecret,
  
  // URI de redirección (debe estar configurada en Keycloak como "Valid Redirect URI")
  // IMPORTANTE: Debe coincidir EXACTAMENTE con la configurada en Keycloak
  redirectUri: environment.redirectUri,

  // URI a la que redirigir después del logout (Keycloak: "Valid redirect URIs" / "Post logout redirect URIs")
  logoutRedirectUri: environment.appUrl,

  // Scopes solicitados
  scopes: environment.scopes,
};
